<div class="error-message" *ngIf="showEstablecimientoError || tankError">Complete los campos obligatorios.</div>
<div class="error-message" *ngIf="!showEstablecimientoError && !tankError && (errorCamposIncorrectos)"> Hay campos introducidos incorrectamente.</div>
<div class="ok-message fade-out" *ngIf="!showEstablecimientoError && !tankError && !errorCamposIncorrectos && pedidoSolicitado && !errorFinal">
    El pedido ha sido solicitado correctamente.</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorFinalMessage}}</div>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">SOLICITAR PEDIDO</span>
            <button mat-icon-button matTooltip="Solicitar pedido" class="gurdar-btn" (click)="guardarUsuario()" [disabled]="waitAfterSave">
                <mat-icon>playlist_add</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario de pedidos DataBeer</span>
    </div>
    <div class="body">

        <!--<div class="input-container2">
            <mat-label class="label-text">Cliente</mat-label>
            <mat-form-field class="custom4">
                <mat-label>-Elige una opción-</mat-label>
                <mat-select [(value)]="selectedCliente" name="est" (selectionChange)="clienteSeleccionado()">
                  <mat-option *ngFor="let est of clientes" [value]="est.id">
                    {{est.name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
        </div>-->

        <div class="input-container2">
            <div class="custom1">
                <mat-icon>store</mat-icon>&nbsp;&nbsp;<span class="fontWeight500">Establecimiento</span>
            </div>
            <form class="custom2">
                <mat-form-field class="width100">
                    <mat-label>Establecimiento</mat-label>
                    <input type="text"
                            placeholder="Elige uno"
                            aria-label="Establecimiento"
                            matInput
                            [formControl]="myControl"
                            [matAutocomplete]="auto"
                            (input)="onInputChanged()">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{option.label}}
                            <!--{{ option.name }} (ID: {{option.identificadorUnico}})-->
                        </mat-option>
                    </mat-autocomplete>
                    <button *ngIf="myControl.value != ''" matSuffix mat-icon-button aria-label="Clear" (click)="limpiarSeleccion()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="showEstablecimientoError" class="custom3">Selecciona un establecimiento</mat-error>
            </form>
        </div>
        
        <div class="input-container3">
            <div class="custom1">
                <mat-icon>settings_input_svideo</mat-icon>&nbsp;&nbsp;<span class="fontWeight500">Tanques</span>
            </div>
            <mat-form-field class="custom4">
                <mat-label>-Tanque-</mat-label>
                <mat-select [(ngModel)]="selectedTank" name="modVer" (selectionChange)="onTankSelectionChanged">
                    <!--<mat-checkbox 
                        [(ngModel)]="selectAllTanks" 
                        (change)="selectAllTanksChanged()" 
                        color="primary" 
                        style="margin-left: 5px;">
                        <span style="font-size: 16px; color: rgb(21, 9, 194)">
                            Seleccionar todos
                        </span>
                    </mat-checkbox>-->
                    <mat-option *ngFor="let tank of numTanks" [value]="tank.id">{{tank.custom_num}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="tankError" class="custom3">Selecciona un tanque</mat-error>
        </div>

        <form [formGroup]="configuracionPedido" class="input-container3">
            <div class="custom1">
                <span class="fontWeight500">Cantidad:</span>
            </div>
            <mat-form-field class="custom5">
                <mat-label class="etiqueta-label">Litros a reponer del producto</mat-label>
                <input matInput type="text" formControlName="litrosCerveza">
            </mat-form-field>
            <mat-error *ngIf="configuracionPedido.get('litrosCerveza')?.hasError('pattern')" 
            class="custom6">
                Ingresa solo <strong>números</strong>
            </mat-error>
        </form>

        <div class="input-container3">
            <div class="custom1">
                <span class="fontWeight500">Producto:</span>
            </div>
            <mat-form-field class="custom4">
                <mat-label>Tipo de cerveza</mat-label>
                <mat-select [(ngModel)]="selectedCerveza" name="modVer">
                    <mat-option *ngFor="let cerveza of cervezas" [value]="cerveza.id">{{cerveza.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
<div class="footer"></div>

